<div class="container bg-light position-relative app-match-detail-page">

    <app-stage-participant [stageParticipantData]="stageParticipantData"></app-stage-participant>

    <app-stage-standings [standingsData]="standingsData"></app-stage-standings>
</div>
